import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { ActionCardsComponent } from './action-cards/action-cards.component';
import { OrderSectionComponent } from './order-section/order-section.component';
import { OrderDetailAccordionComponent } from './order-section/order-detail-accordion/order-detail-accordion.component';

@NgModule({
  declarations: [
    ProfileComponent,
    UserInfoComponent,
    ActionCardsComponent,
    OrderSectionComponent,
    OrderDetailAccordionComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [ProfileComponent]
})
export class ProfileModule {}